import Footer from "components/footer/footer";
import Navbar from "components/navbar";
import Career from "ui/career/career";

const CareerPage = () => {
  return (
    <div>
      <Navbar active="career" />
      <Career />
      <Footer />
    </div>
  );
};

export default CareerPage;
